import { ApplicationConfig, inject, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideOptimus } from '@openng/optimus-ui/config';
import { definePreset } from '@openng/optimus-ui-themes';
import { tratonPreset, tratonComponentOverrides, TRATON_DARK_MODE_SELECTOR } from '@tmt/traton-theme';
import Material from '@openng/optimus-ui-themes/material';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { ConfirmationService, MessageService } from '@openng/optimus-ui/api';
import { LOGGER_CONFIG } from 'tmt-logger';
import { of } from 'rxjs';
import { routes } from 'src/app/app.routes';
import { provideJira } from '@tmt/jira';
import { ApolloClientService } from 'src/app/services/apollo-client.service';
export const appConfig: ApplicationConfig = {
	providers: [
		MessageService,
		ConfirmationService,
		provideJira(() => inject(ApolloClientService).abstractionLayerClient$),
		provideBrowserGlobalErrorListeners(),
		provideRouter(routes),
		provideOptimus({
			theme: {
				options: {
					darkModeSelector: TRATON_DARK_MODE_SELECTOR,
				},
				preset: definePreset(Material, tratonPreset, {
					semantic: {
						colorScheme: {
							light: {
								content: {
									background: '{surface.100}',
									secondaryBackground: '{surface.0}',
								},
							},
						},
					},
					content: {},
					components: tratonComponentOverrides,
				}),
			},
		}),
		provideServiceWorker('ngsw-worker.js', {
			enabled: environment.serviceWorkerEnabled,
			// We primarily use service worker to check for updates, so register ASAP.
			// We might want to change this to "registerWhenStable" if use cases change.
			registrationStrategy: 'registerImmediately',
		}),

		{
			provide: LOGGER_CONFIG,
			useValue: of(environment.logConfig),
		},
	],
};
